import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { KTCard } from '../../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../../_metronic/helpers/components/KTCardBody';
import { RootState } from '../../../../redux/store';
import { durumRozeti, uyariRozeti } from '../../../../helpers/sigortaHesap';
import { tutarYaz } from '../../../../services/HgsOgsService';
import { ilkSigortaListIstegi, SIGORTA_SAYFASI, SigortaKaydi, SigortaService } from '../../../../services/SigortaService';

interface Props {
    vehicleId: string | undefined
}

/**
 * Araç kartı > Poliçeler (28.10.2026, #502): aracın trafik sigortası ve kasko poliçe geçmişi, salt okunur.
 * Poliçeler Genel Giderler > Sigorta / Kasko ekranından girilir; o menüye yetkisi olmayan kullanıcıda bölüm görünmez.
 */
const Policeler = ({ vehicleId }: Props) => {
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.auth)
    const menu = auth.user.user?.data.authorizedMenus.find(x => x.menuName == SIGORTA_SAYFASI);
    const [liste, setListe] = useState<SigortaKaydi[] | undefined>(undefined);

    useEffect(() => {
        if (vehicleId && menu)
            yukle(vehicleId);
    }, [vehicleId])

    const yukle = async (_vehicleId: string) => {
        try {
            const r = await SigortaService.getList({ ...ilkSigortaListIstegi, take: 100, vehicleId: _vehicleId });
            if (!r.isSuccess) {
                toast.error(r.message ?? '');
                setListe([]);
                return;
            }
            setListe((r.data?.list ?? []) as SigortaKaydi[]);
        } catch (error: any) {
            toast.error(error);
            setListe([]);
        }
    }

    if (!vehicleId || !menu)
        return null;

    return (
        <KTCard className="ebbe-card mt-10">
            <KTCardBody>
                <div className="d-flex align-items-center justify-content-between mb-5">
                    <h4 className="text-black m-0">Poliçeler</h4>
                    {
                        menu.canInsert && (
                            <button className="btn btn-sm btn-light-primary" onClick={() => navigate('/sigorta/listadd')}>Yeni Poliçe</button>
                        )
                    }
                </div>
                <div className="text-muted fs-7 mb-3">Trafik sigortası ve kasko poliçeleri Genel Giderler › Sigorta / Kasko ekranından girilir. Satıra çift tıklayınca poliçe açılır.</div>

                <div className="table-responsive">
                    <table className="table align-middle table-row-dashed ebbe-compact-table">
                        <thead>
                            <tr className="text-start text-muted fw-bolder text-uppercase">
                                <th>Belge Türü</th>
                                <th>Poliçe No</th>
                                <th>Durum</th>
                                <th>Başlangıç</th>
                                <th>Bitiş</th>
                                <th className="text-end">Kalan Gün</th>
                                <th>Sigorta Firması</th>
                                <th>Acente</th>
                                <th className="text-end">Tutar</th>
                                <th>Döviz</th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-600 fw-bold">
                            {
                                liste === undefined ? (
                                    <tr><td colSpan={10} className="text-center text-muted">Yükleniyor…</td></tr>
                                ) : liste.length == 0 ? (
                                    <tr><td colSpan={10} className="text-center">Bu araca girilmiş poliçe yok.</td></tr>
                                ) : liste.map(p => (
                                    <tr key={p.sigortaPolicesiId} className="cursor-pointer" onDoubleClick={() => navigate('/sigorta/listadd?id=' + p.sigortaPolicesiId)}>
                                        <td>{p.belgeTuruAdi}</td>
                                        <td>{p.policeNo}</td>
                                        <td><span className={'badge ' + durumRozeti(p.durum)}>{p.durumAdi}</span></td>
                                        <td>{p.baslangicTarihiStr}</td>
                                        <td>{p.bitisTarihiStr}</td>
                                        <td className="text-end"><span className={'badge ' + uyariRozeti(p.uyari)} title={p.uyariAdi}>{p.kalanGun}</span></td>
                                        <td>{p.sigortaFirmasi}</td>
                                        <td>{p.acente}</td>
                                        <td className="text-end">{tutarYaz(p.tutar)}</td>
                                        <td>{p.dovizCinsi}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </KTCardBody>
        </KTCard>
    )
}

export default Policeler;
